import { _ as _define_property } from "@swc/helpers/_/_define_property";
import { COOK_AT_HOME_URL_ID, COZY_APPAREL_URL_ID, FAMILY_TIME_URL_ID, FREE_RETURN_URL_ID, SELF_CARE_URL_ID, WORK_FROM_HOME_URL_ID } from "@faire/retailer-visitor-shared/services/Categories";
export var subheaderForLoggedInUsers = function(strictLocalize) {
    var _obj;
    return _obj = {}, _define_property(_obj, COOK_AT_HOME_URL_ID, strictLocalize({
        id: "UR2xEl",
        defaultMessage: [
            {
                type: 0,
                value: "From cookware to pantry staples"
            }
        ]
    })), _define_property(_obj, FAMILY_TIME_URL_ID, strictLocalize({
        id: "w8U6WG",
        defaultMessage: [
            {
                type: 0,
                value: "Great for kids and pets"
            }
        ]
    })), _define_property(_obj, SELF_CARE_URL_ID, strictLocalize({
        id: "3S2UPn",
        defaultMessage: [
            {
                type: 0,
                value: "Destress and indulge"
            }
        ]
    })), _define_property(_obj, WORK_FROM_HOME_URL_ID, strictLocalize({
        id: "mVn0FK",
        defaultMessage: [
            {
                type: 0,
                value: "Make WFH a little more comfortable"
            }
        ]
    })), _define_property(_obj, COZY_APPAREL_URL_ID, strictLocalize({
        id: "CPr/P8",
        defaultMessage: [
            {
                type: 0,
                value: "Comfy gear for staying home"
            }
        ]
    })), _define_property(_obj, FREE_RETURN_URL_ID, strictLocalize({
        id: "/xWNIV",
        defaultMessage: [
            {
                type: 0,
                value: "For a limited time only, try new products from brands you already know\u2014risk-free."
            }
        ]
    })), _obj;
};
